import { render, staticRenderFns } from "./Gauges.vue?vue&type=template&id=c95f4070&scoped=true&"
import script from "./Gauges.vue?vue&type=script&lang=js&"
export * from "./Gauges.vue?vue&type=script&lang=js&"
import style0 from "./Gauges.vue?vue&type=style&index=0&id=c95f4070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95f4070",
  null
  
)

export default component.exports